import { TClipLogo, TClipPeople } from '@/features/clips/types';
import { PresenceTypeEnum } from '@/types/presences';

import { ItemLayoutType, TimeKeepingSession, TimeKeepingSupportRegistry } from '../types';

import { buildRecordsFromPeople } from './build-records-from-people';
import { buildSupportsFromLogos } from './build-supports-from-logos';

type BuildSessionItemsParams = {
  session: TimeKeepingSession;
  clipLogos: TClipLogo[];
  clipPeoples: TClipPeople[];
};

export const buildSessionItems = ({
  session,
  clipLogos,
  clipPeoples,
}: BuildSessionItemsParams): ItemLayoutType[] => {
  return session.layout.map(item => {
    if (item.presence_type === PresenceTypeEnum.PEOPLE) {
      const entries = clipPeoples.filter(p => p.people_id === item.presence_id);
      return { ...item, supports: [], records: buildRecordsFromPeople(entries) };
    }

    const entries = clipLogos.filter(l => l.logo_id === item.presence_id);
    const fromClip = new Map(buildSupportsFromLogos(entries).map(s => [s.presenceId, s]));
    const sessionLogo = session.logos.find(l => l.id === item.presence_id);
    const logoSupports = sessionLogo?.supports ?? [];
    const supports: TimeKeepingSupportRegistry[] = logoSupports.map(
      supportId => fromClip.get(supportId) ?? { presenceId: supportId, records: [] }
    );
    return { ...item, supports };
  });
};
